import React from "react";

export default function VideoPlayerModal({ videoUrl, onClose }) {
  if (!videoUrl) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/75 p-4" onClick={onClose}>
      <div className="relative bg-white rounded-lg shadow-lg overflow-hidden flex flex-col max-w-2xl w-full" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-800">Video Player</h3>
          <button
            onClick={onClose}
            className="text-gray-700 hover:text-gray-900 text-3xl font-bold leading-none"
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <div className="flex-1 flex items-center justify-center bg-black">
          <video src={videoUrl} controls autoPlay className="max-h-[60vh] max-w-full bg-black" preload="auto" />
        </div>
      </div>
    </div>
  );
} 